// @flow
import React from 'react';
import AnimatingProgressBar from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/AnimatingProgressBar';
import i18n from 'app/common/lib/i18n';
import { getWelcomeBackText } from 'app/common/react/components/growth/activation/NuxUtils/NuxUtils';
import { Box, Heading, Icon, Text } from 'gestalt';

type Props = {
  showWelcomeMsg?: boolean,
  width: number,
};

const LOADING_MODAL_HEIGHT = 500;
const LOADING_MODAL_DURATION = 6000;

const LoginWelcomeLoading = ({ showWelcomeMsg, width }: Props) => (
  <Box alignItems="center" display="flex" justifyContent="center">
    <Box color="white" height={LOADING_MODAL_HEIGHT} width={width} shape="rounded">
      <AnimatingProgressBar duration={LOADING_MODAL_DURATION} finalProgress={95} />
      <Box
        alignItems="center"
        direction="column"
        display="flex"
        height="99%"
        justifyContent="center"
        padding={12}
      >
        <Box marginBottom={showWelcomeMsg ? 6 : 10}>
          <Icon
            accessibilityLabel={i18n._('Loading state for login')}
            color="red"
            icon="pinterest"
            size="40"
          />
        </Box>
        {showWelcomeMsg && (
          <Box paddingY={5} dangerouslySetInlineStyle={{ __style: { textAlign: 'center' } }}>
            <Heading size="sm">{getWelcomeBackText()}</Heading>
          </Box>
        )}
        {showWelcomeMsg ? (
          <Text size="xl" align="center" overflow="normal">
            {i18n._('Ready to discover your new favorite idea?', 'Login loading state description')}
          </Text>
        ) : (
          <Box dangerouslySetInlineStyle={{ __style: { textAlign: 'center' } }}>
            <Heading size="xs" overflow="normal">
              {i18n._(
                'Ready to discover your new favorite idea?',
                'Login loading state description',
              )}
            </Heading>
          </Box>
        )}
      </Box>
    </Box>
  </Box>
);

export default LoginWelcomeLoading;
